<template>
  <div
    :class="{
      'flex h-full flex-grow flex-col border-b-3px text-www-color-neutral-medium-dark shadow-[0_0_12px_rgba(0,0,0,0.16)] transition-colors duration-300 ease-in-out': true,
      'border-b-www-color-primary-lighter bg-www-color-white text-www-color-neutral-medium-dark hover:border-www-color-primary-light':
        !useDarkTheme,
      'border-b-www-color-white bg-www-color-neutral-medium text-www-color-white': useDarkTheme,
    }"
    @mouseenter="translateUp"
    @mouseleave="translateDown"
  >
    <div
      :class="{
        'flex flex-1 flex-col pb-22px pl-22px pr-14px pt-14px md:p-30px': true,
      }"
    >
      <GeneralLink
        _type="generalLink"
        :link="link || []"
        text=""
        :class="{ 'grid w-full': true }"
      >
        <div
          :class="{
            'flex justify-between': true,
          }"
        >
          <h3
            :class="{
              'mb-0 text-base font-black leading-5 md:text-2xl md:leading-7': true,
            }"
          >
            {{ title }}
          </h3>
          <PtcIcon
            v-if="link"
            :class="{
              'h-5 w-25px text-sm font-bold leading-none text-www-color-primary-lighter md:text-xl': true,
              'text-www-color-white': useDarkTheme,
            }"
            name="ptc-arrow-white"
          />
        </div>
      </GeneralLink>
      <p
        :class="{
          'mt-2 block flex-grow text-lg font-medium leading-5': true,
        }"
      >
        {{ description }}
      </p>
    </div>
    <GeneralLink
      _type="generalLink"
      :link="link || []"
      text=""
      :class="{ 'image-container w-full': true }"
    >
      <PtcPicture
        v-if="cardImage?.asset?._ref"
        provider="sanity"
        :src="cardImage?.asset._ref"
        :alt="resolvedImage?.altText || 'manual card image'"
        :modifiers="{
          crop: cardImage?.crop,
          hotspot: cardImage?.hotspot,
          w: 500,
          h: 200,
        }"
        :class="{
          'card-img hidden md:block': true,
        }"
        :img-attrs="{
          class: { 'w-full': true },
        }"
      />
    </GeneralLink>
  </div>
</template>

<script lang="ts" setup>
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
import { translateDown, translateUp } from '~/components/Molecules/Themes/Animation';
import type { ContentManualCard } from '~/sanity/types';

interface Props extends ContentManualCard {
  useDarkTheme?: boolean;
}

const props = defineProps<Props>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.cardImage?.asset?._ref);
</script>

<style lang="scss">
.image-container {
  a {
    height: 100%;
    display: block !important;

    img {
      max-height: 12.5625rem;
      width: 100%;
    }
  }
}
@media (max-width: 768px) {
  .carousel-card {
    .card-img {
      display: block !important;
    }
  }
}
</style>
